const NotificationSms = () => {
    return (
        <h1>test</h1>
    )
}
export default NotificationSms;